var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"wrapper"},[_c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h1',{staticClass:"display-1"},[_vm._v("403")]),_c('h2',{staticClass:"display-4"},[_vm._v("Forbidden")]),_c('p',{staticClass:"lead"},[_vm._v("You are not authorized to access this resource.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }